import { Environments } from '@shared/constants/environments';

export const getIsProdEnv = (): boolean => getCurrentEnv() === Environments.prod;

export const getCurrentEnv = (): string => process.env.REACT_APP_STAGE!;
